// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ba79d46a","453":"075d3d71","455":"f3e9004d"}[chunkId] + ".chunk.js";
};